import { UserPermission } from '../data/models/permission.model';
import { useAppSelector } from './useAppSelector';
import * as userSlice from '../data/user.slice';
import { useHasPermission } from './permissions/useHasPermission';

export function useIsClientPortalAdminUser(): boolean {
  const user = useAppSelector(userSlice.selectLoggedInUserInfo);
  const clientPermission: UserPermission = {
    resource: 'tripleg',
    action: 'readbasic',
    scope: 'client',
  };

  const userPermission: UserPermission = {
    resource: 'users',
    action: 'createbasic',
    scope: 'client',
  };

  const hasClientPermission = user && useHasPermission(user, clientPermission);
  const hasUserPermission = user && useHasPermission(user, userPermission);
  return hasClientPermission && hasUserPermission;
}
